import { CountriesTable } from "@/components/CountriesTable";

export function CountriesPage() {
  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-6 text-2xl font-bold">Countries</h1>
      <CountriesTable />
    </div>
  );
}
